import React, { lazy, Suspense, useEffect, useState } from "react";

// Importaciones
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Divider } from "@mui/material";
import useNews from "../../../hooks/useNews";
import usePgiModules from "../../../hooks/useModules";
import images from "../../../exports/images";
import ModuleBlockNews from "../../../components/news/ModuleBlockNews";
import CarouselMobile from "../../../components/carousel/CarouselMobile";
import CarouselMobileProdEspeciales from "../../../components/carousel/CarouselMobileProdEspeciales";

const SidebarSlidesNews = lazy(() => import("../../../components/pgi/SidebarSlidesNews"));
const NavTensoNews = lazy(() => import("../../../components/nav/NavTensoNews"));
const CardNews = lazy(() => import("../../../components/news/CardNews"));
// const Carousel = lazy(() => import("../../../components/carousel/Carousel"));
// const CarouselProdEspeciales = lazy(() =>
//   import("../../../components/carousel/CarouselProdEspeciales")
// );
const CardVideo = lazy(() => import("../../../components/news/CardVideo"));
const GrandCardBlog = lazy(() => import("../../../components/news/GrandCardBlog"));
const SliderNews = lazy(() => import("../../../pages/SliderNews"));
const BannerPub = lazy(() => import("../../../components/BannerPub"));

const TensoBlogReplicaPgi = () => {
  const isTensoBlogReplicaPgiPage = true;
  const [busqueda, setBusqueda] = useState("todos");
  const { news, newsVideo } = useNews();
  const [busquedaNews, setBusquedaNews] = useState([]);
  const [homeModules, setHomeModules] = useState([]);
  const [loading, setLoading] = useState(true);

  const { getModulesByParams } = usePgiModules();

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(res.sort((a, b) => a.position - b.position));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChange = (event) => {
    // console.log(event.target.defaultValue);
    setBusqueda(event.target.defaultValue);
  };

  useEffect(() => {
    setBusquedaNews(news);
  }, [news]);
  useEffect(() => {
    if (busqueda === "todos") {
      setBusquedaNews(news);
    } else {
      const filterNews = news.filter((n) => n.category.toLowerCase() === busqueda);
      setBusquedaNews(filterNews);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busqueda]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const newsGrandCard = news?.filter(
    (noticia) => noticia.deleted === false && noticia.visible === true && noticia.publish === true
  );

  return (
    <>
      <NavTensoNews />
      {/* Carousel */}
      <div id="blur-prueba">
        <section>
          <SliderNews />
        </section>
        <button className="botton-editar-pginews settings_button-pleno centrado-button">
          {" "}
          <a href="/pgi/edit-news">Editar Slide News</a>
        </button>
      </div>

      {/* NOTICIAS */}

      <div id="blur-prueba">
        <div className="botton-editar-pginews margin-boton-news">
          <SidebarSlidesNews replicaPgi={true} />
          <button className=" settings_button-pleno overlay-replica-button">
            {" "}
            <a href="/pgi/edit-news">Editar noticia</a>
          </button>
        </div>

        <div className="container">
          <div id="seccion-noticias-videos-h" className="grid-replica-pgi">
            <div className="seccion-noticias">
              {loading ? (
                <>
                  <GrandCardBlog loading={loading} />
                  <GrandCardBlog loading={loading} />
                  <GrandCardBlog loading={loading} />
                </>
              ) : (
                newsGrandCard
                  .slice(0, 3)
                  .map(
                    (noticia, index) =>
                      noticia.deleted === false &&
                      noticia.visible === true &&
                      noticia.publish === true && (
                        <GrandCardBlog loading={loading} key={index} noticia={noticia} />
                      )
                  )
              )}
            </div>
            {/* Ultimos videos y cuadrante de suscripcion */}

            <div className="seccion-videos">
              <div className="text-video">
                <div className="titulo-seccion-video noticias-hr">
                  <p className="titulo-roboto">Últimos videos</p>
                </div>
                <div className="video-destacado">
                  <div id="videos-recomendados">
                    {newsVideo
                      .slice(0, 3)
                      .map(
                        (noticia, index) =>
                          noticia.deleted === false &&
                          noticia.visible === true && <CardVideo key={index} noticia={noticia} />
                      )}
                  </div>
                </div>
                <div className="cuadrante-suscripcion">
                  <div>
                    <h5>Newsletter</h5>
                    <p>
                      Recibí información especializada de la industria de la construcción y de
                      Tensolite: Videos instructivos, novedades del sector, grandes ofertas, y mucho
                      más.
                    </p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button className="settings_button-pleno bg-p-secondary my-2 d-flex justify-content-center button-footer">
                      <a
                        target="__blank"
                        rel="noopener"
                        href="https://mailchi.mp/tensolite/newsletters"
                      >
                        SUSCRIBIRSE
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modulos de publicidad */}
        {homeModules.map((item, index) => {
          switch (item.title) {
            case "Banner_publicitario":
              if (item.visible.includes("news")) {
                return (
                  <>
                    <BannerPub key={index} className="w-100" idProducto={"news"} />
                  </>
                );
              }
              break;
            case "Bloque_info":
              if (item.visible.includes("home")) {
                return <ModuleBlockNews key={index} editPgi={true} idProducto={"news"} />;
              }
              break;
            default:
          }
        })}
        {homeModules.map((item, index) => {
          switch (item.title) {
            case "Carrousel_deLinea":
              if (item.visible.includes("news")) {
                return (
                  <div key={index} className="container producto-linea">
                    <CarouselMobile
                      isTensoBlogReplicaPgiPage={isTensoBlogReplicaPgiPage}
                      images={images[0]}
                    />
                    {/* <Carousel images={images[0]} /> */}
                  </div>
                );
              }
              break;
            case "Carrousel_especial":
              if (item.visible.includes("news")) {
                return (
                  <div key={index} className="container producto-linea">
                    <CarouselMobileProdEspeciales
                      isTensoBlogReplicaPgiPage={isTensoBlogReplicaPgiPage}
                      images={images[1]}
                    />
                    {/* <CarouselProdEspeciales images={images[1]} /> */}
                  </div>
                );
              }
              break;
            default:
          }
        })}

        {/* Card Noticias */}

        <div className="container in">
          <div className="title-noticias ">
            <h5>Mas noticias</h5>
            <Divider />
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="todos"
              >
                <FormControlLabel
                  value="todos"
                  control={<Radio />}
                  label="Todos"
                  onChange={handleChange}
                />
                <FormControlLabel
                  value="diseño"
                  control={<Radio />}
                  label="Diseño"
                  onChange={handleChange}
                />
                <FormControlLabel
                  value="produccion"
                  control={<Radio />}
                  label="Producción"
                  onChange={handleChange}
                />
                <FormControlLabel
                  value="video"
                  control={<Radio />}
                  label="Videos"
                  onChange={handleChange}
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="seccion-cards-noticias ">
            <div id="seccion-noticas">
              <div className="">
                <div className="masonry mansory_tensoblog_replica">
                  {loading ? (
                    <>
                      <CardNews loading={true} tensoblog={true} />
                      <CardNews loading={true} tensoblog={true} />
                    </>
                  ) : (
                    <>
                      {busquedaNews.map(
                        (noticia, index) =>
                          noticia.deleted === false &&
                          noticia.visible === true && <CardNews key={index} noticia={noticia} />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TensoBlogReplicaPgi;
